import { Button } from '@chakra-ui/react';
import { usePharma } from '@/providers/PharmaProvider';
import { useCapabilities } from '@/providers/useCapabilities';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { CRCForm } from '../components/CRCForm';
import { BundleStatusReportPanel } from '@/components/ParticipantTracker/BundleStatusReportPanel';
import { Layout } from '../components/Layout';

export const CRCSelect = () => {
  const navigate = useNavigate();
  const { setIsSiteLoggedIn, isCRC } = usePharma();
  const { isDfiCrc, isDfiStudyTeam, isDfiVv, canManageDevicesPage } = useCapabilities();

  const handleSiteSelect = () => {
    setIsSiteLoggedIn(true);
    navigate('/app/');
  }

  // if (isSiteLoggedIn)
  //   return <Navigate to="/app/" />;

  // DFI18231: DFI CRC/StudyTeam/VV reach this selector too. subUsers come from the backend
  // GetPharma1Sites (now study-aware). A READONLY DFI Study Team stays read-only once acting.
  // // redirect to root if not CRC (or a DFI acting role)
  if (!isCRC && !isDfiCrc && !isDfiStudyTeam && !isDfiVv)
    return <Navigate to="/" />;

  return (
    <Layout title="Log In to a Site | Vivid Vision Perimetry" secondary={<BundleStatusReportPanel />}>
      <CRCForm onSuccess={handleSiteSelect} />
      {/* DFI18231: VV operators get a Manage Devices entry point from the Site Selection screen,
          in addition to acting as a site. canManageDevicesPage here === VV (SIENNA CRC and DFI
          CRC/Study Team don't have it; DFI Device Admin lands on /auth/pv instead). */}
      {canManageDevicesPage && (
        <Link to="/devices" className="font-medium text-blue-600 hover:text-blue-500 w-full">
          <Button w="full" size="lg" colorScheme="blue" variant="outline" mt={4}>
            Manage Devices
          </Button>
        </Link>
      )}
    </Layout>
  );
};
